<template>
  <v-flex style="display: block !important;" :fill-height="(displayImgIntro || displayResults) && displayPerfumeDetails == false" :noFlexPfo="(isMobile && !displayImgIntro) || (displayPerfumeDetails == true && isMobile)">
     <v-layout column pa-0 :style="{height: displayResults == false ? '100%' : (isWebbApp == 'true' ? '100vh' : '100%'), flex: 0, display: 'flex; !important', float: 'unset'}">
      <v-flex :style="{flex: 0}" mb-0>
        <v-flex xs12 :pa-4="!displayResults && isFirstSearch && !isMobile" :class="{'pfo-mb-2': isMobile}" :pt-0="displayResults || !isFirstSearch" :px-2="displayResults || !isFirstSearch || isMobile"  >

          <v-text-field id="pfo-search"
                        v-model="keyword"
                        class="pfo-search pfo-search-ar elevation-2"
                        slot="input"
                        hide-details
                        inputText
                        ref="pfosearch"
                        @input="onKey"
                        :loading="isLoading"
                        :disabled="isDisabled"
                        :color="redColor"
                        v-if="locale.substring(0,2) == 'ar'"
                        isp_ignore
          >
            <template v-slot:append>
              <v-icon :color="redColor">favorite</v-icon>
            </template>
            <template v-slot:label><div class="body-1" :style="{color: redColor, paddingLeft: '5px'}" style="font-size: 14px !important;">{{wiyfp}}</div>
            </template>
            <template v-slot:default>
              <div  style="border:none"></div>
            </template>
            <template v-slot:prepend>
              <v-icon :color="redColor">search</v-icon>
            </template>
          </v-text-field>
          <v-text-field id="pfo-search"
                        v-model="keyword"
                        class="pfo-search elevation-2"
                        slot="input"
                        hide-details
                        inputText
                        ref="pfosearch"
                        @input="onKey"
                        :loading="isLoading"
                        :disabled="isDisabled"
                        :color="redColor"
                        v-if="locale.substring(0,2) != 'ar'"
                        isp_ignore
          >
            <template v-slot:prepend>
              <v-icon :color="redColor">favorite</v-icon>
            </template>
            <template v-slot:label><div class="body-1" :style="{color: redColor, paddingLeft: '5px'}" style="font-size: 14px !important;">{{wiyfp}}</div>
            </template>
            <template v-slot:default>
              <div  style="border:none"></div>
            </template>
            <template v-slot:append>
              <v-icon :color="redColor">search</v-icon>
            </template>
          </v-text-field>        </v-flex>
      </v-flex>
      <v-flex imgContainer  v-if="!displayResults && isFirstSearch">
          <v-img @click="focusTextfield()" contain :style="{height: '100%'}" :src="perfImgIntro"/>
      </v-flex>

     <v-flex :style="{height: '90%', flex: 0}" v-if="displayResults">

        <v-list two-line class="orders2b-layout" dense>
          <template v-for="(item, index) in items">
            <v-list-item :style="{flexDirection: locale.substring(0,2) == 'ar' ? 'row-reverse' : 'row'}" :key="index" avatar @click="setFavourite(item)">

              <v-list-item-action class="justify-center">
                <img :src="item._source.thumb_src" height="50" class="imgoverridelist50">
 
              </v-list-item-action>

              <v-list-item-content v-if="renderReady(item)" :class="{pfotextalignright: isRTL, pfotextalignleft: !isRTL}">
                <v-list-item-subtitle class="text--primary">{{ item._source.name_standard[searchLocale] || item._source.name_standard['en']}}</v-list-item-subtitle>
                <v-list-item-subtitle>{{ item._source.brand_name_standard && (item._source.brand_name_standard[searchLocale] || item._source.brand_name_standard["en"]) }}</v-list-item-subtitle>
              </v-list-item-content>

            </v-list-item>
            <v-divider v-if="index + 1 < items.length" :key="`divider-${index}`" class="vperfdivider"></v-divider>
          </template>
        </v-list>

      </v-flex>

  </v-layout>
  </v-flex>
</template>
<script>

  import toolsMixin from "../mixin/toolsMixin"
  import sha1 from "../../node_modules/js-sha1"

  export default {
    name: 'SearchElastic',
    mixins: [toolsMixin],
    components: {
    },

    data () {
      return {
        pfokey: null,
        slt: null,
        thumb_size: null,
        thumb_cdn_base: null,
        displayResults: false,
        displayImgIntro: false,
        matchpanel: false,
        twocolors: 'rgba(30,30,30,1)',
        keyword: null,
        items: [],
        perfImgIntro: process.env.VUE_APP_IMG_INTRO_EN,
        perfTaglineIntro: process.env.VUE_APP_TAGLINE_INTRO_EN,
        favourite: "Aucun favori",
        wiyfp: process.env.VUE_APP_WIYFP_EN,
        stateFR: false,
        searchLocale: "en",
        searchOverrideLocale: "en",
        changeSearchHeight: true
      }
    },
    props: {
      isDisabled: {},
      isLoading: {},
      isFirstSearch : {
        type: Boolean,
        default: () => true
      },
      isRefresh: {
        type: Boolean,
        default: () => false
      },
      locale: {
        type: String,
        default: () => 'en'
      },
      country: {
        type: String,
        default: () => 'UK'
      },
      displayPerfumeDetails: {
        type: Boolean,
        default: () => false
      },
      isMobile: {
        type: Boolean,
        default: () => false
      },
      isWebbApp: {
        type: String,
        default: () => false
      },
      isRTL: {
        type: Boolean,
        default: () => false
      }
    },
    watch: {
      isRefresh(refresh) {
        if (refresh) {
          this.keyword = ''
        }
      },
      isFirstSearch(fs) {
          this.keyword = ''
        if (fs) {
          this.displayImgIntro = true
          this.changeSearchHeight = true
        }
      },
      displayPerfumeDetails(newval, oldval) {
        console.log('new displayPerfumeDetails', newval, oldval)
      }
    },
    computed: {
      redColor () {
        return process.env.VUE_APP_COLOR
      }
    },
    mounted: function () {
      let urlParams = new URLSearchParams(window.location.search)
      if (urlParams.has('product')) {
        let perfFav = {
          id: urlParams.get('product'),
          name: "",
          thumb_image_url: "",
          brand_name: ""
        }
        console.log(perfFav)
        // console.log(perfItem)
        // if (typeof window._paq !== 'undefined') {window._paq.push(['trackEvent', 'PFO Widget','Search', 'keyword:'+this.keyword+' - Selected Perfume:'+perfFav.name[this.searchLocale]+' - '+perfFav.brand_name[this.searchLocale]+' - id:'+perfFav.id])}

        this.displayResults = false
        this.displayImgIntro = false
        this.$emit('set-favourite-se', perfFav, this.isMobile)
      }

      console.log(this.pfokey)
      if (urlParams.has('product_retailer_url')) {
        console.log(process.env.VUE_APP_API_BACKEND + '/api/show_by_url?url=' + urlParams.get('product_retailer_url'))
                fetch(process.env.VUE_APP_API_BACKEND + '/api/show_by_url?url=' + urlParams.get('product_retailer_url'), {
          method: 'GET',
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
            Authorization: "Business " + this.pfokey,
            Accept: "version=2"
          }
        })
            .then(
                res => res.json(),
            )
            .then(res => {

              if (res.response != null) {
                let perfFav = {
                  id: res.response.id,
                  name: "",
                  thumb_image_url: "",
                  brand_name: ""
                }

                this.displayResults = false
                this.displayImgIntro = false
                this.$emit('set-favourite-se', perfFav, this.isMobile)

                }
            })
      }

    },
    created: function () {
      if (process.env.VUE_APP_PFOKEY) {
        this.pfokey = process.env.VUE_APP_PFOKEY
      }
      if (process.env.VUE_APP_IS_WEBAPP) {
        this.isWebbApp = process.env.VUE_APP_IS_WEBAPP
      }
      if (process.env.VUE_APP_SLT) {
        this.slt = process.env.VUE_APP_SLT
      }
      if (process.env.VUE_APP_THUMB_SIZE) {
        this.thumb_size = process.env.VUE_APP_THUMB_SIZE
      }
      if (process.env.VUE_APP_THUMB_CDN_BASE) {
        this.thumb_cdn_base = process.env.VUE_APP_THUMB_CDN_BASE
      }
      //this.locale=JSON.parse(localStorage.getItem('langPFO'))
      if (this.locale==="fr") {
        this.wiyfp = process.env.VUE_APP_WIYFP_FR
        this.perfImgIntro = this.isMobile ? process.env.VUE_APP_IMG_INTRO_MOBILE_FR : process.env.VUE_APP_IMG_INTRO_FR
        this.perfTaglineIntro = process.env.VUE_APP_TAGLINE_INTRO_FR
      }
      else if (this.locale==="es") {
        this.wiyfp = process.env.VUE_APP_WIYFP_ES
        this.perfImgIntro = this.isMobile ? process.env.VUE_APP_IMG_INTRO_MOBILE_ES : process.env.VUE_APP_IMG_INTRO_ES
        this.perfTaglineIntro = process.env.VUE_APP_TAGLINE_INTRO_ES
      }
      else if (this.locale==="de") {
        this.wiyfp = process.env.VUE_APP_WIYFP_DE
        this.perfImgIntro = this.isMobile ? process.env.VUE_APP_IMG_INTRO_MOBILE_DE : process.env.VUE_APP_IMG_INTRO_DE
        this.perfTaglineIntro = process.env.VUE_APP_TAGLINE_INTRO_DE
      }
      else if (this.locale==="ja") {
        this.wiyfp = process.env.VUE_APP_WIYFP_JP
        this.perfImgIntro = this.isMobile ? process.env.VUE_APP_IMG_INTRO_MOBILE_JP : process.env.VUE_APP_IMG_INTRO_JP
        this.perfTaglineIntro = process.env.VUE_APP_TAGLINE_INTRO_JP
      }
      else if (this.locale==="ar") {
        this.wiyfp = process.env.VUE_APP_WIYFP_AR
        this.perfImgIntro = this.isMobile ? process.env.VUE_APP_IMG_INTRO_MOBILE_AR : process.env.VUE_APP_IMG_INTRO_AR
        this.perfTaglineIntro = process.env.VUE_APP_TAGLINE_INTRO_AR
      }
      else if (this.locale==="pt") {
        this.wiyfp = process.env.VUE_APP_WIYFP_PT
        this.perfImgIntro = this.isMobile ? process.env.VUE_APP_IMG_INTRO_MOBILE_PT : process.env.VUE_APP_IMG_INTRO_PT
        this.perfTaglineIntro = process.env.VUE_APP_TAGLINE_INTRO_PT
      }
      else if (this.locale==="sv") {
        this.wiyfp = process.env.VUE_APP_WIYFP_SV
        this.perfImgIntro = process.env.VUE_APP_IMG_INTRO_SV
        this.perfImgIntro = this.isMobile ? process.env.VUE_APP_IMG_INTRO_MOBILE_SV : process.env.VUE_APP_IMG_INTRO_SV
        this.perfTaglineIntro = process.env.VUE_APP_TAGLINE_INTRO_SV
      } else if (this.locale==="ru") {
        this.wiyfp = process.env.VUE_APP_WIYFP_RU
        this.perfImgIntro = process.env.VUE_APP_IMG_INTRO_RU
        this.perfImgIntro = this.isMobile ? process.env.VUE_APP_IMG_INTRO_MOBILE_RU : process.env.VUE_APP_IMG_INTRO_RU
        this.perfTaglineIntro = process.env.VUE_APP_TAGLINE_INTRO_RU
      } else if (this.locale==="tr") {
        this.wiyfp = process.env.VUE_APP_WIYFP_TR
        this.perfImgIntro = process.env.VUE_APP_IMG_INTRO_TR
        this.perfImgIntro = this.isMobile ? process.env.VUE_APP_IMG_INTRO_MOBILE_TR : process.env.VUE_APP_IMG_INTRO_TR
        this.perfTaglineIntro = process.env.VUE_APP_TAGLINE_INTRO_TR
      } else if (this.locale==="ms") {
        this.wiyfp = process.env.VUE_APP_WIYFP_MS
        this.perfImgIntro = process.env.VUE_APP_IMG_INTRO_MS
        this.perfImgIntro = this.isMobile ? process.env.VUE_APP_IMG_INTRO_MOBILE_MS : process.env.VUE_APP_IMG_INTRO_MS
        this.perfTaglineIntro = process.env.VUE_APP_TAGLINE_INTRO_MS
      }  else if (this.locale==="ko") {
        this.wiyfp = process.env.VUE_APP_WIYFP_KO
        this.perfImgIntro = process.env.VUE_APP_IMG_INTRO_KO
        this.perfImgIntro = this.isMobile ? process.env.VUE_APP_IMG_INTRO_MOBILE_KO : process.env.VUE_APP_IMG_INTRO_KO
        this.perfTaglineIntro = process.env.VUE_APP_TAGLINE_INTRO_KO
      } else if (this.locale==="nl") {
        this.wiyfp = process.env.VUE_APP_WIYFP_NL
        this.perfImgIntro = process.env.VUE_APP_IMG_INTRO_NL
        this.perfImgIntro = this.isMobile ? process.env.VUE_APP_IMG_INTRO_MOBILE_NL : process.env.VUE_APP_IMG_INTRO_NL
        this.perfTaglineIntro = process.env.VUE_APP_TAGLINE_INTRO_NL
      } else if (this.locale==="th") {
        this.wiyfp = process.env.VUE_APP_WIYFP_TH
        this.perfImgIntro = process.env.VUE_APP_IMG_INTRO_TH
        this.perfImgIntro = this.isMobile ? process.env.VUE_APP_IMG_INTRO_MOBILE_TH : process.env.VUE_APP_IMG_INTRO_TH
        this.perfTaglineIntro = process.env.VUE_APP_TAGLINE_INTRO_TH
      } else if (this.locale==="zh") {
        this.wiyfp = process.env.VUE_APP_WIYFP_ZH
        this.perfImgIntro = process.env.VUE_APP_IMG_INTRO_ZH
        this.perfImgIntro = this.isMobile ? process.env.VUE_APP_IMG_INTRO_MOBILE_ZH : process.env.VUE_APP_IMG_INTRO_ZH
        this.perfTaglineIntro = process.env.VUE_APP_TAGLINE_INTRO_ZH
      }  else if (this.locale==="it") {
        this.wiyfp = process.env.VUE_APP_WIYFP_IT
        this.perfImgIntro = process.env.VUE_APP_IMG_INTRO_IT
        this.perfImgIntro = this.isMobile ? process.env.VUE_APP_IMG_INTRO_MOBILE_IT : process.env.VUE_APP_IMG_INTRO_IT
        this.perfTaglineIntro = process.env.VUE_APP_TAGLINE_INTRO_IT
      }  else {
        this.wiyfp = process.env.VUE_APP_WIYFP_EN
        this.perfImgIntro = this.isMobile ? process.env.VUE_APP_IMG_INTRO_MOBILE_EN : process.env.VUE_APP_IMG_INTRO_EN
        this.perfTaglineIntro = process.env.VUE_APP_TAGLINE_INTRO_EN
      }
      console.log('this.isFirstSearch', this.isFirstSearch)
      console.log("localStorage.getItem('pfo_display_clicked_match')", localStorage.getItem('pfo_display_clicked_match'))
      if (this.isFirstSearch && JSON.parse(localStorage.getItem('pfo_display_clicked_match'))!==true) {
        this.keyword=''
        this.displayImgIntro = true
      }
      if (this.isRefresh) {
        this.keyword = ''
      }
    },
    methods: {
      onKey() {
        console.log(this)
        if (this.keyword) {

          this.locale = JSON.parse(localStorage.getItem('langPFO'))
          this.searchLocale = this.locale
          this.searchOverrideLocale = this.locale
          if (this.locale === "sv") {
            this.searchOverrideLocale = "sv_se"
            this.searchLocale = "sv_se"
          }

          var bodySearch = '{\n' +
              ' "size": ' + process.env.VUE_APP_SEARCH_COUNT +', \n' +
              ' "query": { "bool": {"should": [\n'+
              ' {"multi_match": {"query": "' + this.keyword + '","fields": ["name_standard.' + this.searchOverrideLocale + '","brand_name_standard.' + this.searchOverrideLocale + '"],"boost": 90}},{"multi_match": {"query": "' + this.keyword + '","fields": ["name_standard.' + this.searchOverrideLocale + '","brand_name_standard.' + this.searchOverrideLocale + '"],"fuzziness": 1}},{"match_phrase_prefix" : {"name_standard.' + this.searchOverrideLocale + '" : {"query" : "' + this.keyword + '","max_expansions" : 10}}},\n'+
              ' {"multi_match": {"query": "' + this.keyword + '","fields": ["name_standard.en","brand_name_standard.en"],"boost": 90}},{"multi_match": {"query": "' + this.keyword + '","fields": ["name_standard.en","brand_name_standard.en"],"fuzziness": 1}},{"match_phrase_prefix" : {"name_standard.en" : {"query" : "' + this.keyword + '","max_expansions" : 10}}}\n'+
              ']}}' +
              '}'


          fetch('https://6053737d69f147e7a3cb36b072136154.eu-central-1.aws.cloud.es.io:9243/perfumist-products-dev2/_search', {
            method: 'POST',
            headers: {
              'Content-type': 'application/json; charset=UTF-8',
              Authorization: 'ApiKey MXo4bFFIRUJsOC16bGJrZ3pOMEI6UHRwSGtDMU1UUld1X3RfUjQ1eDhjQQ=='
            },
            body: bodySearch
          })
              .then(
                  res => res.json()
              )
              .then(res => {
                this.Message = "Fetching..."
                this.items = res.hits.hits
                // console.log(this.items)

                let filename_base = null
                let ins = null
                let thumb_with_sha1 = null
                for (let i = 0; i < this.items.length; i++) {
                  filename_base = this.items[i]['_id'] + '-' + this.thumb_size
                  ins = filename_base + '-' + this.slt
                  thumb_with_sha1 = this.thumb_cdn_base + filename_base + '-' + sha1(ins).slice(-8) + '.jpg'
                  this.items[i]['_source']['thumb_src'] = thumb_with_sha1
                  this.items[i]['_source']['id'] = this.items[i]['_id']
                }
                this.displayResults = true
                this.setDisplayDetails(false)
              })
              .catch(err => {
                console.log(err)
              })
              .finally(() => {
                this.isLoading = false
              })
        } // if keyword is not empty
        else {
          this.isFirstSearch=true
          this.keyword=''
        }
      },
      setFavourite: function (perfItem) {
        console.log("TOTO")
        let perfFav = {
          id: perfItem['_id'],
          name: perfItem._source['name_standard'],
          thumb_image_url: perfItem._source['thumb_src'],
          brand_name:  perfItem._source['brand_name_standard']
        }
        console.log(perfFav)
        console.log(perfItem)
        if (typeof window._paq !== 'undefined') {window._paq.push(['trackEvent', 'PFO Widget','Search', 'keyword:'+this.keyword+' - Selected Perfume:'+perfFav.name[this.searchLocale]+' - '+perfFav.brand_name[this.searchLocale]+' - id:'+perfFav.id])}

        this.displayResults = false
        this.displayImgIntro = false
        this.$emit('set-favourite-se', perfFav, this.isMobile)
      },
      focusTextfield : function() {
        document.getElementById("pfo-search").focus()
      },
      setDisplayDetails: function (toDisplay) {
        this.changeSearchHeight = false
        this.$emit('set-display-details', toDisplay)
      },
      clear: function () {
        this.keyword=''
      }
    },
    filters: {
      capitalize: function (value) {
        if (!value) return ''
        value = value.toString()
        return value.charAt(0).toUpperCase() + value.slice(1)
      },
      percent: function (value) {
        if (!value) return ''
        value = value*100
        value = value.toString()
        if (value===100) value = value.substring(0,3)+"%"
        else value = value.substring(0,2)+"%"
        return value
      },
      value100: function (value) {
        if (!value) return 0
        value = value*100
        value = value.toString()
        return value
      },
      notnull: function (value) {
        if (value===null) return ' '
        return value
      },
    }
  }
</script>
<style>
  .imgContainer {
    width: calc(100% - 16px);
    background-color: white;
    border-radius: 6px;
    margin-left: auto;
    margin-right: auto;
    height: 95%;
  }
  .pfo-search-height {
    height:330px;
  }
  .pfo-search{
    color: rgba(30,30,30,1);
    background-color: white !important;
    border-bottom-color: #43454b;
    border-bottom-width: thin;
    border-radius: 8px;
    padding-left: 5px;
    padding-right: 5px;
  }

  .pfo-search-ar {

  }

  .pfo-search-ar input {
    text-align: end; 
  }

  .pfo-search-ar label {
    right: 0px !important;
    left: unset !important;
  }

  #pfo-search{
    background-color: white !important;
  }
  .layout.row {
    margin: unset;
  }
  .vperfdivider {
    margin: unset;
  }
  .orders2b-layout {
    position: relative;
    padding-left: 16px;
    top: 4px;
    bottom: 0;
    right: 0;
    left: 0;
    width: 100%;
    height: 100%;
    flex: 1;
    overflow-y: scroll;
  }
  .orders3-layout {
    position: relative;
    width:100px;
    height: 310px;
    overflow-y: scroll;
    display: block;
    white-space: nowrap;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  div div .noFlexPfo {
    flex: 0 !important;
  }
  .match {
    color: redColor;
    font-weight: bold;
    font-size: 14px;
  }
  .list__tile__action { min-width: 150px; padding-left: 10%; }
  .justify-center{
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }
  .imgoverridelist50{
    height: 50px !important;
    min-width: 100px;
    object-fit: contain;
  }
  .pfotextalignright {
    text-align: right;
  }
  .pfotextalignleft {
    text-align: left;
  }
  .pfo-mb-2 {
    margin-bottom: 8px;
  }
  .labelsearch {
    font-size: 11px !important;
    max-width: 100% !important;
    line-height: 10px !important;
  }
  .v-input__slot:before {
    border: none !important;
  }

  /* .v-input__slot {

  } */

  .v-responsive__sizer {
    padding-bottom: unset !important;
    display: block !important;
  }
  .v-list-item__subtitle {
    font-size: 12px !important;
    line-height: 14px !important;
  }

  .v-image__image {
    display: block !important;
  }

  .text--primary {
    font-size: 13px !important;
    line-height: 15px !important;
  }
/* 
  .media[dir="ltr"] .search-item {
    flex-direction: row;
  }

  .search-item:dir(rtl) {
    flex-direction: row-reverse;
  }


  .search-item:dir(ltr) {
    flex-direction: row;
  } */
</style>

<style lang="scss">
.v-text-field {
  input {
    border-style: none !important;
    border-color: #FFFFFF !important;
    font-weight: normal !important;
    text-transform: initial;
    color: #000000 !important;
    margin-bottom: inherit;
    font-size: 16px;
  }
  label {
    font-weight: normal !important;
    text-transform: initial;
    margin-top: 0px;
    font-size: 14px;
    max-width: 100% !important;
    line-height: 10px !important;
    white-space: break-spaces !important;
  }
  input:focus {
    border-style: none !important;
    border-color: #FFFFFF !important;
    box-shadow: unset !important;
    caret-color: #000000 !important;
  }
}
</style>
